<div cdkTrapFocus>
  <ng-content></ng-content>
</div>
